import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLuckyCanvas from '@lucky-canvas/vue'
import '@/assets/font/fontFamily.css'
// vant
import Vant from 'vant'
import 'vant/lib/index.css'
import $cookies from 'js-cookie'
Vue.use(Vant)
Vue.use(VueLuckyCanvas)
Vue.prototype.$cookies = $cookies
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
